import { createExpandModel } from '@gmini/common/lib/classifier-editor/DependencyTree/model/expandModel'

export const dependencyExpandModel = createExpandModel()
